import React from "react"

import { Action } from "shared/types/Action"
import { WithClassName } from "shared/types/WithClassName"

import { ProjectActionType } from "features/project-management/types/ProjectActionType"
import { ProjectModel } from "features/project-management/types/ProjectModel"

import { ProjectHeaderView } from "./ui/ProjectHeaderView"

export interface ProjectHeaderProps extends WithClassName {
  projectModel?: ProjectModel | null
  allowedActions?: ProjectActionType[]
  additionalActions?: Action[]
  isLoading?: boolean

  onClick?: (event: React.MouseEvent) => void
}

function ProjectHeaderComponent(props: ProjectHeaderProps) {
  return <ProjectHeaderView {...props} />
}

export const ProjectHeader = React.memo(
  ProjectHeaderComponent
) as typeof ProjectHeaderComponent
